// src/pages/ProfilePage.js
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BottomNav from '../components/BottomNav';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="profile-root">
      <div className="profile-header">
        <h1>Profile</h1>
      </div>

      {user ? (
        <div className="profile-body">
          <div className="profile-avatar-row">
            <div className="profile-avatar">{user.shopper?.name?.[0]?.toUpperCase() || '?'}</div>
            <div>
              <p className="profile-name">{user.shopper?.name}</p>
              <p className="profile-email">{user.email}</p>
            </div>
          </div>
          <div className="profile-section">
            <button className="profile-row" onClick={() => navigate('/')}>🏠 Browse Stores</button>
            <button className="profile-row" onClick={() => navigate('/search')}>⌕ Search Deals</button>
          </div>
          <button className="profile-logout" onClick={() => { logout(); navigate('/'); }}>Sign Out</button>
        </div>
      ) : (
        <div className="profile-guest">
          <div className="guest-icon">👤</div>
          <h2>You're browsing as a guest</h2>
          <p>Sign in to lock deals, track your saved offers, and get personalised recommendations.</p>
          <button className="auth-submit" onClick={() => navigate('/auth')}>Sign In or Create Account</button>
        </div>
      )}

      <BottomNav active="profile" />
    </div>
  );
}
